import { useEffect, useCallback } from 'react';

export default function useNativeMessaging({ handlers = {} } = {}) {
    const postMessageToNative = useCallback((message) => {
        if (window?.ReactNativeWebView?.postMessage) {
            window?.ReactNativeWebView?.postMessage(JSON.stringify(message));
        } else {
            console.warn('ReactNativeWebView.postMessage가 없습니다.');
        }
    }, []);

    useEffect(() => {
        const handleStructuredMessage = (event) => {
            let data;
            if (typeof event?.data === 'string') {
                try {
                    if (!event.data.trim().startsWith('{')) return;
                    data = JSON.parse(event.data);
                } catch (e) {
                    console.warn('JSON 파싱 실패:', event.data);
                    return;
                }
            } else {
                data = event.data;
            }

            if (data?.from !== 'NATIVE') return;

            const key = 'message';
            if (typeof handlers[key] === 'function') {
                handlers[key](data);
            } else {
                console.warn('등록된 message 핸들러 없음:', data);
            }
        };

        // 커스텀 이벤트 핸들러
        const handleCustomEvent = (event) => {
            const key = event.type;
            if (typeof handlers[key] === 'function') {
                handlers[key](event);
            } else {
                console.warn(`등록된 CustomEvent 핸들러 없음: ${key}`);
            }
        };

        window.addEventListener('message', handleStructuredMessage);
        document.addEventListener('message', handleStructuredMessage);

        Object.keys(handlers).forEach((key) => {
            window.addEventListener(key, handleCustomEvent);
            document.addEventListener(key, handleCustomEvent);
        });

        return () => {
            window.removeEventListener('message', handleStructuredMessage);
            document.removeEventListener('message', handleStructuredMessage);

            Object.keys(handlers).forEach((key) => {
                window.removeEventListener(key, handleCustomEvent);
                document.removeEventListener(key, handleCustomEvent);
            });
        };
    }, [handlers]);

    return { postMessageToNative };
}
